

export class StihlSearchData {
    Id: string;
    TermTypeCode: string;
    PublishDate: string;
    Name: string;
    Title: string;
    Terms: string;
    Type: number;
    ImageUri: any;
    FileUri: any;
    Path: string;
    Icon: string;
    IconColor: string;
}

export class StihlSearch {
    from_item: number;
    to_item: number;
    total_item: number;
    term: string;
    items: StihlSearchData[];
}